import {Box, Button, Tabs, Text} from '@chakra-ui/react'
import {useCan} from '@/shared/hooks/use-permissions'
import {useTranslate} from '@tolgee/react'
import {LuPlus} from 'react-icons/lu'
import {AddGfrDialog} from './dialogs/add-gfr-dialog'
import {dialog} from '@/modules/layout'
import {useGetPatientGfrLabs} from '@/modules/patients/api/use-get-patient-gfr-labs'
import {GfrTable} from './gfr-table'
import {Patient} from '@cypro/engine/schema'

export function GFRLab({patient}: {patient: Patient}) {
  const {t} = useTranslate('common')
  const canEditPatient = useCan('patients.edit')
  const [labs] = useGetPatientGfrLabs(patient.id)

  return (
    <Tabs.Content
      value="gfr_lab"
      spaceY="8"
      display="flex"
      flexDirection="column"
      flex="1"
      minHeight="0"
      overflowY="auto"
    >
      <Box
        display="flex"
        flexDirection="row"
        width="100%"
        gap="8"
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Box
          display="flex"
          flexDirection="row"
          width="100%"
          justifyContent="space-between"
          alignItems="center"
          paddingTop={'4'}
          paddingBottom={'1'}
        >
          <Box display="flex" flexDirection="column" width="100%" gap="1">
            <Text fontSize="md" fontWeight="medium">
              {t('gfr_lab.title')}
            </Text>
            <Text fontSize="sm" fontWeight="normal" color="fg.muted">
              {t('gfr_lab.description')}
            </Text>
          </Box>
        </Box>
        <Box display="flex" flexDirection="row" gap="3">
          {canEditPatient && (
            <Button
              size="md"
              variant="plain"
              colorPalette="cyan"
              paddingInline="0"
              onClick={async () => {
                await dialog.open('add-patient-gfr', {
                  children: <AddGfrDialog patient={patient} />,
                })
              }}
            >
              <LuPlus />
              <Text fontSize="sm" fontWeight="medium">
                {t('new_gfr_entry')}
              </Text>
            </Button>
          )}
        </Box>
      </Box>
      <GfrTable gfrLabs={labs} patient={patient} />
    </Tabs.Content>
  )
}
